import { Injectable, Injector } from '@angular/core';
import { HubSdkBase } from '../utilities/hub-sdk-base/hub-sdk.base';
import { ProcessingStepCount } from '../managers/case.manager';
import { Observable, shareReplay } from 'rxjs';
import { ProductionJobView } from "@models/ui/production-job-view.model";

@Injectable({
	providedIn: 'root'
})
export class CaseHubSdk extends HubSdkBase {
	public productionJobs$: Observable<ProductionJobView[]> =
		this.on$<ProductionJobView[]>('productionJobs').pipe(shareReplay(1));

	public autoRedactionJobs$: Observable<ProductionJobView[]> =
		this.on$<ProductionJobView[]>('autoRedactionJobs').pipe(shareReplay(1));

	public processing$ =
		this.on$<ProcessingStepCount[]>('processing').pipe(shareReplay(1));

	constructor(injector: Injector) {
		super(injector, 'case');
	}
}
